import { render } from "./Authority.vue?vue&type=template&id=59c384be&scoped=true"
import script from "./Authority.vue?vue&type=script&lang=ts"
export * from "./Authority.vue?vue&type=script&lang=ts"

import "./Authority.vue?vue&type=style&index=0&id=59c384be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-59c384be"

export default script